// src/pages/OtManagement.js
import React, { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DelBox from "../comps/DelBox";
import DataTable from "react-data-table-component"; // new dependency
import Select from "react-select";
import Swal from "sweetalert2";
import { toast } from "react-toastify";


const OtManagement = () => {
  // logos / config
  const [headerLogo, setHeaderLogo] = useState("");
  const [watermarkLogo, setWatermarkLogo] = useState("");
  const [footerImage, setFooterImage] = useState("");
  // near other useState calls
const [hoveredRow, setHoveredRow] = useState(null);


  // lists + records
  const todayISO = new Date().toISOString().split("T")[0];
  const [records, setRecords] = useState([]); // OT rows from server
  const [docList, setDocList] = useState([]); // doctors
  const [caseList, setCaseList] = useState([]); // cases
  const [bedsList, setBedsList] = useState([]); // beds
  const [nursesList, setNursesList] = useState([]); // nurses

  // UI / filters / misc
  const [loading, setLoading] = useState(true);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);

  const [filters, setFilters] = useState({
    page_no: 0,
    per_page: 10,
    from: todayISO,
    to: todayISO,
    search_key: "",
    doctor_filter: ""
  });

  /* ----------------- Helpers ----------------- */
  function safeParseSessionLdata() {
    const stored = sessionStorage.getItem("ldata");
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch (e) {
      console.warn("Failed to parse ldata", e);
      return null;
    }
  }

  const getDoctorNameById = (id) => {
    if (!id) return "";
    const doc = (docList || []).find((d) => String(d.user_id) === String(id));
    return doc ? doc.fname : "";
  };

 
  const fetchCaseNameById = async (catId) => {
    if (!catId && catId !== 0) return "";
    try {
      // quick local check first
      const local = getCaseNameByIdSafe(catId);
      if (local) return local;
  
      const fd = new FormData();
      fd.append("cat_id", catId);
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatByIdUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });
  
      console.log("fetchCaseNameById response:", resp?.data);
  
      if (resp && resp.data && resp.data.status && resp.data.cat_dt) {
        const cat = resp.data.cat_dt;
        const caseName = cat.cat_name || cat.name || "";
  
        // merge into local caseList
        setCaseList(prev => {
          const existing = Array.isArray(prev) ? [...prev] : [];
          const key = String(cat.cat_id ?? cat.case_id ?? cat.id ?? "");
          const idx = existing.findIndex(x => String(x.cat_id ?? x.case_id ?? x.id ?? "") === key);
          if (idx === -1) existing.push(cat);
          else existing[idx] = { ...existing[idx], ...cat };
          return existing;
        });
  
        return caseName;
      }
    } catch (err) {
      console.warn("fetchCaseNameById error", err);
    }
    return "";
  };
  
  const getDoctorNameByIdSafe = (id) => {
    if (!id) return "";
    const doc = (docList || []).find(d => String(d.user_id) === String(id));
    return doc ? doc.fname : "";
  };
  // Safe lookup of case name by id from formData.case
  // safe lookup of case name from local case list
  // safe local lookup with flexible key names
  const getCaseNameByIdSafe = (id) => {
    if (!id && id !== 0) return "";
    const cases = Array.isArray(caseList) ? caseList : [];
    const found = cases.find(c => {
      return String(c.cat_id ?? c.case_id ?? c.id ?? "").trim() === String(id).trim();
    });
    return found ? (found.cat_name || found.name || "") : "";
  };
  const fetchCaseList = async () => {
    try {
      const fd = new FormData();
      fd.append("cat_type", "case");
      fd.append("page_no", "none");
      fd.append("par_by", (ldata && ldata.user_id) ? String(ldata.user_id) : "1");
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("get_cat_list response:", response?.data);
      if (response.data && response.data.status) {
        const records = Array.isArray(response.data.records) ? response.data.records : [];
        setCaseList(records);
        return records;
      } else {
        setCaseList([]);
        return [];
      }
    } catch (err) {
      console.error("fetchCaseList error", err);
      setCaseList([]);
      return [];
    }
  };
  
  // get bed name by id. If bedsArray omitted, use formData.beds from state.

// ---------- Bed helpers (use bedsList state) ----------
const getBedNameById = (id) => {
  if (id === undefined || id === null || id === "") return "";
  const v = String(id).trim();

  // try id match (support keys like bed_id or id)
  const byId = (bedsList || []).find(b => String(b.bed_id ?? b.id ?? "").trim() === v);
  if (byId) return byId.bed_name ?? byId.name ?? v;

  // exact name match (case-insensitive)
  const byName = (bedsList || []).find(b => String(b.bed_name ?? b.name ?? "").toLowerCase().trim() === v.toLowerCase());
  if (byName) return byName.bed_name ?? byName.name ?? v;

  // fuzzy contains match
  const fuzzy = (bedsList || []).find(b => (String(b.bed_name ?? b.name ?? "").toLowerCase()).includes(v.toLowerCase()));
  if (fuzzy) return fuzzy.bed_name ?? fuzzy.name ?? v;

  // fallback to raw id string
  return String(id);
};

// Fetch beds and store in bedsList (used by PDFs and renders)
const initBeds = async () => {
  const storedData = sessionStorage.getItem("ldata");
  if (!storedData) return;
  try {
    const fd = new FormData();
    fd.append("page_no", "none");
    fd.append("bed_user", "1");
    const resp = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    if (resp && resp.data && resp.data.status && Array.isArray(resp.data.records)) {
      setBedsList(resp.data.records);
    } else {
      setBedsList([]);
    }
  } catch (err) {
    console.warn("initBeds error", err);
    setBedsList([]);
  }
};

// Minimal mount effect — we set ldata and fetch beds.
// NOTE: the main initialization (fetchConfigData + initLists + initData) is already performed
// in the later useEffect. This effect only ensures bedsList is filled early.
useEffect(() => {
  console.log('Component mounted (beds init)');
  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
    const parsed = JSON.parse(storedData);
    setLdata(parsed);
    // don't call undefined initData2/3/4 anymore
    initBeds();
  }
  return () => { console.log('Component unmounted'); };
}, []);


  
useEffect(() => {
  console.log('Component mounted');

  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
    const parsed = JSON.parse(storedData);
    setLdata(parsed);

    // load supporting lists (doctors/cases/nurses/beds) and then load OT records
    // initLists fetches doc/case/nurse/beds; initData fetches OT records
    // initBeds is safe to call (will just set bedsList) — initLists already fetches beds too,
    // but calling initBeds here is harmless and ensures bedsList is available early.
    initLists();
    initData();
    initBeds();
  } else {
    // no session data — stop any loading state if needed
    setLoading(false);
  }

  return () => {
    console.log('Component unmounted');
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  
  // convert image url to base64 (for jsPDF)
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const resp = await fetch(url);
      if (!resp.ok) return null;
      const blob = await resp.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn("imageUrlToBase64:", err);
      return null;
    }
  };
  

  // returns true when an OT record is editable (i.e. registered less than 24 hours ago)
  // returns true when an OT record is editable (i.e. registered less than 24 hours ago)
// Accepts either ot_datetime or ot_reg_date (otDatetime preferred)
const canEditOt = (otDatetimeOrRegDate) => {
  const dateStr = otDatetimeOrRegDate || "";
  if (!dateStr) return true; // keep editable if no date provided
  // prefer ot_datetime strings but also accept ot_reg_date if that's passed
  const d = new Date(dateStr);
  if (isNaN(d)) return true; // if invalid date, allow edit (safer fallback)
  const msSince = Date.now() - d.getTime();
  return msSince < 24 * 60 * 60 * 1000; // less than 24 hours
};

  
  // click handler that enforces 24h rule and navigates to edit when allowed
  const handleEditClick = (row) => {
    const editable = canEditOt(row.ot_datetime);
    if (!editable && !isAdmin) { // allow admin to bypass
      Swal.fire({
        icon: "warning",
        title: "Edit not allowed",
        text: "This OT was registered more than 24 hours ago and cannot be edited.",
        confirmButtonText: "OK",
      });
      return;
    }
  
    sessionStorage.setItem("ot_dt", JSON.stringify(row));
    window.location.href = "/add_ot";
  };
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      // if click is not inside any of our dropdown containers
      if (!e.target.closest(".ot-dropdown-container")) {
        setDropdownOpenIndex(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  
  const numberToWords = (num) => {
    if (num === undefined || num === null || num === "") return "";
    num = Number(num);
    if (isNaN(num)) return "";
    num = Math.round(num);
    const a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen",
    ];
    const b = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
    if (num.toString().length > 9) return "overflow";
    const n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return "";
    let str = "";
    str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore " : "";
    str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh " : "";
    str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand " : "";
    str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred " : "";
    str += n[5] != 0 ? ((str != "") ? "and " : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) : "";
    return str.charAt(0).toUpperCase() + str.slice(1).trim();
  };

  function formatDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${dd}-${months[d.getMonth()]}-${d.getFullYear()}`;
  }
// format "2025-09-30 16:38:42" (or other ISO-ish strings) to "30-Sep-2025 04:38 PM"
// returns "" for falsy/invalid input
function formatDateTime(dtStr) {
  if (!dtStr) return "";
  try {
    // try Date parse first (works for many formats)
    let d = new Date(dtStr);
    if (isNaN(d.getTime())) {
      // fallback: replace space with 'T' (common server format "YYYY-MM-DD HH:mm:ss")
      const t = String(dtStr).trim().replace(" ", "T");
      d = new Date(t);
    }
    if (isNaN(d.getTime())) return String(dtStr);

    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();

    // 12-hour time
    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12;
    if (hh === 0) hh = 12;
    const mm = String(d.getMinutes()).padStart(2, "0");

    return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
  } catch (e) {
    return String(dtStr);
  }
}

  /* --------------- Fetch / Init --------------- */

  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data && res.data.status) {
        setHeaderLogo(res.data.header_logo || "");
        setWatermarkLogo(res.data.logo || "");
        setFooterImage(res.data.footer_logo || "");
      }
    } catch (err) {
      //console.error("Error fetching config:", err);
    }
  };

  // fetch doctors + cases + nurses + beds + item store
  const initLists = async () => {
    try {
      // doctors
     // doctors — fetch all (no pagination) so we can show full list in searchable select
const fdDoc = new FormData();
fdDoc.append("type", "doctor");
fdDoc.append("search_key", "");
fdDoc.append("page_no", "none"); // ask server for all doctors
fdDoc.append("user_cre_by", "1");
const respDoc = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fdDoc);
if (respDoc.data && respDoc.data.status && Array.isArray(respDoc.data.records)) {
  setDocList(respDoc.data.records);
}


      // cases
      const fdCase = new FormData();
      fdCase.append("cat_type", "case");
      fdCase.append("page_no", "none");
      fdCase.append("par_by", "1");
      const respCase = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fdCase);
      if (respCase.data && respCase.data.status && Array.isArray(respCase.data.records)) {
        setCaseList(respCase.data.records);
      }

      // nurses
      const fdN = new FormData();
      fdN.append("type", "nurse");
      fdN.append("search_key", "");
      fdN.append("page_no", "0");
      fdN.append("user_cre_by", "1");
      const respN = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fdN);
      if (respN.data && respN.data.status && Array.isArray(respN.data.records)) {
        setNursesList(respN.data.records);
      }

      // beds
      const fdBeds = new FormData();
      fdBeds.append("page_no", "none");
      fdBeds.append("bed_user", "1");
      const respBeds = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fdBeds);
      if (respBeds.data && respBeds.data.status && Array.isArray(respBeds.data.records)) {
        setBedsList(respBeds.data.records);
      }
    } catch (err) {
      //console.error("initLists error:", err);
    }
  };

  // initData sends explicit filter values to server
  // initData sends explicit filter values to server (NO user filter -> fetch all records)
const initData = async (pageNo = null, opts = {}) => {
  setLoading(true);
  const parsed = safeParseSessionLdata();
  if (parsed) setLdata(parsed);
  else {
    setLoading(false);
    return;
  }

  try {
    const fd = new FormData();
    const pNo = pageNo !== null ? String(pageNo) : String(filters.page_no ?? 0);
    fd.append("page_no", pNo);

    const from = opts.from ?? filters.from;
    const to = opts.to ?? filters.to;
    const search = opts.search_key ?? filters.search_key;
    const docFilter = opts.doctor_filter ?? filters.doctor_filter;

    fd.append("search_key", String(search ?? ""));
    fd.append("from", String(from ?? ""));
    fd.append("to", String(to ?? ""));
    // NOTE: removed fd.append("ot_user", ...) so server will return ALL OT records (not per-user)

    if (docFilter) fd.append("ot_doctor", String(docFilter));

    const response = await axios.post(AppConst.BASE_URL + AppConst.getOtListUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.data && response.data.status && Array.isArray(response.data.records)) {
      setRecords(response.data.records);
    } else {
      setRecords([]);
      console.warn("get_ot_list responded with no records or false status:", response.data);
    }
  } catch (err) {
    console.error("initData error:", err);
    setRecords([]);
  } finally {
    setLoading(false);
  }
};


  // make sure lists are loaded before fetching records (fixes case blank issue)
  useEffect(() => {
    const parsed = safeParseSessionLdata();
    setLdata(parsed);
    setIsAdmin(parsed && (parsed.role_id === 1 || String(parsed.role_id) === "1"));

    const run = async () => {
      await fetchConfigData();
      await initLists();    // wait lists (doc / case / beds) to be available
      await initData();     // then fetch ot records (so case names map correctly)
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* --------------- Delete / Edit ---------------- */
// robust bed resolver - returns { bedName, wardName, bedObj }
const resolveBed = (raw, beds = []) => {
  if (!raw && raw !== 0) return { bedName: "", wardName: "", bedObj: null };

  const v = String(raw).trim();

  // try id match (support keys like bed_id, bedId, bed)
  const byId = beds.find(b =>
    String(b.bed_id ?? b.id ?? b.bedId ?? "").trim() === v
  );
  if (byId) return { bedName: byId.bed_name ?? byId.name ?? "", wardName: byId.cat_name ?? byId.ward_name ?? "", bedObj: byId };

  // try exact name match (case-insensitive)
  const byName = beds.find(b => String(b.bed_name ?? b.name ?? "").toLowerCase().trim() === v.toLowerCase());
  if (byName) return { bedName: byName.bed_name ?? byName.name ?? "", wardName: byName.cat_name ?? byName.ward_name ?? "", bedObj: byName };

  // fuzzy contains match
  const fuzzy = beds.find(b => (String(b.bed_name ?? b.name ?? "").toLowerCase()).includes(v.toLowerCase()));
  if (fuzzy) return { bedName: fuzzy.bed_name ?? fuzzy.name ?? "", wardName: fuzzy.cat_name ?? fuzzy.ward_name ?? "", bedObj: fuzzy };

  // not found - return raw string as bedName (so PDF always shows something)
  return { bedName: v, wardName: "", bedObj: null };
};

// add near helpers
const resolveBedFromList = (rawBed) => {
  if (!rawBed && rawBed !== 0) return { bedName: "", wardName: "" };
  const v = String(rawBed).trim();
  if (!Array.isArray(bedsList)) return { bedName: v, wardName: "" };

  const byId = bedsList.find(b => String(b.bed_id ?? b.id ?? "").trim() === v);
  if (byId) return { bedName: byId.bed_name ?? byId.name ?? v, wardName: byId.cat_name ?? byId.ward_name ?? "" };

  const byName = bedsList.find(b => String(b.bed_name ?? b.name ?? "").toLowerCase().trim() === v.toLowerCase());
  if (byName) return { bedName: byName.bed_name ?? byName.name ?? v, wardName: byName.cat_name ?? byName.ward_name ?? "" };

  const fuzzy = bedsList.find(b => (String(b.bed_name ?? b.name ?? "").toLowerCase()).includes(v.toLowerCase()));
  if (fuzzy) return { bedName: fuzzy.bed_name ?? fuzzy.name ?? v, wardName: fuzzy.cat_name ?? fuzzy.ward_name ?? "" };

  return { bedName: v, wardName: "" };
};


  const delItem = async (editItem) => {
    try {
      const fd = new FormData();
      fd.append("ot_id", String(editItem.ot_id));
      const response = await axios.post(AppConst.BASE_URL + AppConst.delOtUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data && response.data.status) {
        initData();
      }
    } catch (err) {
      console.error("delItem error:", err);
    }
  };

  /* ----------------- PDF / Print helpers ----------------- */
  // I preserved all your PDF functions and logic exactly. (No functional change.)

  const generateOtReceiptPdf = async (receiptData) => {
    if (!receiptData) {
      console.error("No OT receipt data available to generate PDF.");
      return;
    }
  
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    // Header image
    const headerImageBase64 = await imageUrlToBase64(receiptData.config.headerLogoUrl);
    if (headerImageBase64) {
      doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, 80);
    }
  
    // Title box
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setDrawColor(0);
    doc.rect(40, 90, pageWidth - 80, 25);
    doc.text("OT Receipt", pageWidth / 2, 107, { align: "center" });
  
    // Patient & OT details
    const leftX = 50;
    const rightX = pageWidth / 2 + 20;
    let y = 140;
  
    const printDetail = (label, value, x, y) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${label} :`, x, y);
      doc.setFont("helvetica", "normal");
      doc.text(`${value || ""}`, x + 95, y);
    };
  
    // Left column
    printDetail("UHID No", receiptData.patient.uhid, leftX, y);
    printDetail("OT No", receiptData.patient.regNo, leftX, (y += 15));
    printDetail("Patient Name", receiptData.patient.name, leftX, (y += 15));
    printDetail("Address", receiptData.patient.address, leftX, (y += 15));
    printDetail("Age/Sex", receiptData.patient.ageSex, leftX, (y += 15));
    printDetail("OT Doctor", receiptData.doctor, leftX, (y += 15));
  
    // Right column
    y = 140;
    printDetail("Date", formatDate(receiptData.date), rightX, y);
    printDetail("DOA", formatDate(receiptData.doa), rightX, (y += 15));
    printDetail("Case", receiptData.case, rightX, (y += 15));
    printDetail("Ward", receiptData.ward, rightX, (y += 15));
    printDetail("Bed", receiptData.bed, rightX, (y += 15));
    printDetail("Asst. Nurse 1", receiptData.nurse, rightX, (y += 15));
  
    // Inventory Consumables Table
    let startY = y + 40; // safe start position
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Inventory Consumables", 40, startY);
  
    autoTable(doc, {
      startY: startY + 10,
      head: [["S.No.", "Name", "Quantity"]],
      body: receiptData.consumables.map((item) => [
        item.sno,
        item.name,
        item.quantity,
      ]),
      theme: "grid",
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: "bold",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 50, halign: "center" },
        1: { cellWidth: "auto" },
        2: { cellWidth: 80, halign: "center" },
      },
      margin: { left: 40, right: 40 },
    });
  
    let finalY = doc.lastAutoTable?.finalY || startY + 40;
  
    // Signature
  doc.setFont("helvetica", "normal");
  doc.text("(Authorised Signatory)", pageWidth - 60, finalY + 40, {
    align: "right",
  });
  
    // Open in new tab
    const pdfBlobUrl = doc.output("bloburl");
    window.open(pdfBlobUrl, "_blank");
  };
  
  const handlePrintOtReceipt = async (row = null) => {
    try {
      // row is passed from table; if caller didn't pass, make it empty object
      const data = row || {};
  
      // ensure bedsList is available (initLists sets bedsList)
      if (!Array.isArray(bedsList) || bedsList.length === 0) {
        // fetch just beds to avoid refetching everything (you already have fetchBeds in AddOt)
        try {
          const fd = new FormData();
          fd.append("page_no", "none");
          fd.append("bed_user", "1");
          const respBeds = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd);
          if (respBeds?.data?.status && Array.isArray(respBeds.data.records)) {
            setBedsList(respBeds.data.records);
          }
        } catch (e) {
          console.warn("Failed to fetch bedsList fallback:", e);
        }
      }
  
      // Resolve bed robustly from bedsList (id or name)
      const rawBed = data.ot_bed ?? data.bed ?? data.ot_bed_id ?? "";
      let resolvedBed = null;
      let wardName = "";
      let bedName = "";
  
      if (Array.isArray(bedsList) && bedsList.length > 0 && rawBed !== "" && rawBed !== null && rawBed !== undefined) {
        const v = String(rawBed).trim();
  
        // id match (support numeric/string)
        resolvedBed = bedsList.find(b => String(b.bed_id ?? b.id ?? "").trim() === v);
        if (!resolvedBed) {
          // exact name match (case-insensitive)
          resolvedBed = bedsList.find(b => String(b.bed_name ?? b.name ?? "").toLowerCase().trim() === v.toLowerCase());
        }
        if (!resolvedBed) {
          // fuzzy contains
          resolvedBed = bedsList.find(b => (String(b.bed_name ?? b.name ?? "").toLowerCase()).includes(v.toLowerCase()));
        }
  
        if (resolvedBed) {
          bedName = resolvedBed.bed_name ?? resolvedBed.name ?? String(rawBed);
          wardName = resolvedBed.cat_name ?? resolvedBed.ward_name ?? "";
        }
      }
  
      // If still not resolved, try to see if the row already contains bed/ward strings
      if (!bedName) {
        if (data.ot_bed_name) {
          bedName = data.ot_bed_name;
        } else if (data.bed_name) {
          bedName = data.bed_name;
        } else if (rawBed) {
          // fallback: use raw value as bed display text
          bedName = String(rawBed);
        } else {
          bedName = "";
        }
      }
      if (!wardName) {
        if (data.ot_ward_name) wardName = data.ot_ward_name;
        else if (data.ward_name) wardName = data.ward_name;
        // else keep empty
      }
  
      // debug log if we couldn't find bed info
      if ((!bedName || bedName.trim() === "") && rawBed) {
        console.warn("Bed lookup returned empty in OtManagement. rawBed:", rawBed, "bedsList length:", bedsList.length, "row:", data);
      }
  
      // case resolution (use your existing helper)
      let caseName = "";
      if (data.ot_case) {
        caseName = getCaseNameByIdSafe(data.ot_case);
        if ((!caseName || caseName.trim() === "") && data.ot_case) {
          caseName = await fetchCaseNameById(data.ot_case);
        }
      }
  
      const doctorName = getDoctorNameByIdSafe(data.ot_doctor);
      const nurseName = data.ot_nurse_name || "";
  
      const receiptData = {
        config: { headerLogoUrl: headerLogo },
        patient: {
          uhid: data.ot_uhid_no || "",
          regNo: data.ot_number || "",
          name: data.ot_patient_name || "",
          address: data.ot_patient_address || "",
          ageSex: data.ot_patient_gender || ""
        },
        date: data.ot_datetime || new Date().toISOString(),
        doa: data.ot_reg_date || new Date().toISOString(),
        purpose: data.ot_purpose || "",
        ward: wardName || "",
        bed: bedName || "",
        doctor: doctorName,
        case: caseName,
        nurse: nurseName,
        consumables: (data.otitems || []).map(it => ({ name: it.ot_item_name || "", quantity: it.store_min_qty || it.ot_item_price || "" }))
      };
  
      await generateOtReceiptPdf(receiptData);
    } catch (err) {
      console.error("handlePrintOtReceipt:", err);
      toast.error("Failed to generate OT Receipt");
    }
  };
  
  // show patient details using uhid (or row if available)
const handleViewClick = async (uhid, row = {}) => {
  try {
    // If you already have full patient info on `row`, use it; otherwise fetch by UHID
    let patient = null;

    if (row && (row.ot_patient_name || row.ot_patient_age || row.ot_patient_gender)) {
      patient = {
        name: row.ot_patient_name || "",
        age: row.ot_patient_age || "",
        gender: row.ot_patient_gender || "",
        referredDoctor: row.referred_doctor || getDoctorNameByIdSafe(row.ot_ref_doctor) || "", // adjust field names as needed
        otSurgeon: row.ot_doctor_name || getDoctorNameByIdSafe(row.ot_doctor) || "",
        asstSurgeon: row.asst_surgeon || row.ot_asst_surgeon || "",
        asstNurses: row.ot_assistant_nurses || row.ot_asst_nurse || "",
        anesthesiaSurgeon: row.anesthesia_name || getDoctorNameByIdSafe(row.ot_anesthesia_doctor) || "",
        uhid: uhid || (row.ot_uhid_no || "")
      };
    } else if (uhid) {
      // example fetch by UHID (adjust endpoint & param names to your API)
      const fd = new FormData();
      fd.append("uhid", String(uhid));
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getPatientByUhidUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (resp?.data?.status && resp.data.record) {
        const p = resp.data.record;
        patient = {
          name: p.name || p.patient_name || "",
          age: p.age || p.patient_age || "",
          gender: p.gender || p.patient_gender || "",
          referredDoctor: p.referred_by || "",
          otSurgeon: p.ot_surgeon || "",
          asstSurgeon: p.asst_surgeon || "",
          asstNurses: p.assistant_nurses || "",
          anesthesiaSurgeon: p.anesthesia_surgeon || "",
          uhid: p.uhid || uhid
        };
      }
    }

    if (!patient) {
      toast.info("No patient details available");
      return;
    }

    // Format HTML for SweetAlert (you can replace with a modal component if preferred)
    const html = `
      <div style="text-align:left">
        <p><strong>UHID:</strong> ${patient.uhid || ""}</p>
        <p><strong>Name:</strong> ${patient.name || ""}</p>
        <p><strong>Age / Gender:</strong> ${patient.age || ""} / ${patient.gender || ""}</p>
        <p><strong>Referred Doctor:</strong> ${patient.referredDoctor || ""}</p>
        <p><strong>OT Surgeon:</strong> ${patient.otSurgeon || ""}</p>
        <p><strong>Assistant Surgeon:</strong> ${patient.asstSurgeon || ""}</p>
        <p><strong>Assistant Nurses:</strong> ${patient.asstNurses || ""}</p>
        <p><strong>Anesthesia Surgeon:</strong> ${patient.anesthesiaSurgeon || ""}</p>
      </div>
    `;

    await Swal.fire({
      title: "Patient Details",
      html,
      width: 600,
      confirmButtonText: "Close"
    });
  } catch (err) {
    console.error("handleViewClick:", err);
    toast.error("Failed to load patient details");
  }
};

  

  const generateConsentFormPdf = async (formData) => {
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;
    const contentWidth = pageWidth - (margin * 2);
    let y = 0; // Yeh variable page par vertical position ko track karega
  
    // --- 1. Header Image ---
    const headerImageBase64 = await imageUrlToBase64(formData.config.headerLogoUrl);
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 90); // Image ki height adjust kar sakte hain
    }
    y = 100; // Header ke neeche se shuru karo
  
    // --- 2. Patient Details ---
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Left side details
    doc.text(`Name : ${formData.patient.name}`, margin, y);
    doc.text(`Bed : ${formData.patient.bed || 'N/A'}`, margin, y += 15);
    doc.text(`OT Doctor : ${formData.consultant.name}`, margin, y += 15);
  
    // Right side details (same lines pe)
    y -= 30; // Y ko wapas upar le jao
    const rightX = pageWidth / 2 + 60;
    doc.text(`Age/S : ${formData.patient.age} / ${formData.patient.gender}`, rightX, y);
    doc.text(`UHID NO : ${formData.patient.uhid}`, rightX, y += 15);
    y += 30; // Y ko wapas neeche le aao
  
    // Helper function to print a centered, bold, underlined title
    const printTitle = (title) => {
        y += 25;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.text(title, pageWidth / 2, y, { align: 'center' });
        const textWidth = doc.getTextWidth(title);
        doc.setLineWidth(1);
        doc.line((pageWidth - textWidth) / 2, y + 2, (pageWidth + textWidth) / 2, y + 2); // Underline
        y += 20;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
    };
    
    // Helper function for long paragraphs with text wrapping
    const printParagraph = (text) => {
        const lines = doc.splitTextToSize(text, contentWidth);
        doc.text(lines, margin, y);
        y += (lines.length * 12) + 10; // Line height * number of lines + gap
    };
  
    // Helper function for signature lines
    const printSignatureLine = (label) => {
        const labelWidth = doc.getTextWidth(label);
        doc.text(label, margin, y);
        doc.line(margin + labelWidth + 5, y - 2, margin + labelWidth + 200, y - 2); // Dotted line
        y += 25;
    };
    
    // --- 3. ADMISSION CONSENT FORM Section ---
    printTitle('ADMISSION CONSENT FORM');
  
    const consentText = `I ${formData.patient.name} Gender/${formData.patient.gender} Age ${formData.patient.age} Y C/O ${formData.patient.guardian} understanding that my health condition requires inpatient admission. I consent to, and authorize testing, treatment and hospital care at this hospital. All the terms and conditions were explained to me in my known language and I have understood. I hereby promise to pay the hospital charges for all services and goods provided to me.`;
    printParagraph(consentText);
    
    y += 20;
    doc.text('Signature of Patient/Relative ......................................', margin, y);
    doc.text('Relation with the Patient ......................................', pageWidth / 2, y);
    y += 25;
    doc.text('Date/Time ......................................', margin, y);
    y += 25;
    doc.text('Witness ......................................', margin, y);
    
    // --- 4. LETTER OF UNDERTAKING Section ---
    printTitle('LETTER OF UNDERTAKING');
    
    const undertakingText = `I have been appraised of the rules and regulations of the hospital and also the charges of give my consent to be treatment request you to admit me/patient for medical treatment. I am remitting the examined/ for the patient to be advance of Rs. 0 and undertake to pay any further advances when due and the wholeexamined by the treatment charges as per hospital bills on presentation by the hospital authorities. RefundDoctors/Consultants/Nurses of of any amount due to me, may be given to me or the person who is authorised by methe hospital. Undergo essential Dr. ${formData.consultant.name} and his specimen signature is also attested by me. If anytests including procedures for refund is made by cheque may be sent to the address mentioned below. diagnosis and take treatment suggested by the doctors.`;
    printParagraph(undertakingText);
  
    // Check if we need a new page
    if (y > pageHeight - 150) {
        doc.addPage();
        y = margin;
    }
    
    const legalText = `I agree that any medico legal disputes regarding the patient?s treatment and stay in the hospital will be only subjected to the jurisdiction of courts of ..................................................... and no other courts`;
    printParagraph(legalText);
  
    y += 20;
    doc.text('Name & Signature of Patient\'s relative ..................................', margin, y);
    doc.text('Relationship ..........................', pageWidth / 2 +20, y);
    y += 25;
    doc.text('Name & Signature of Patient ...........................................', margin, y);
  
    // --- 5. NOTICE Section ---
    printTitle('NOTICE');
    const noticeText = `Information provided at the time of admission regarding the name, age and address, mode, time and place of accident,duration of symptoms etc. will not be changed under any circumstances as per the order of Supreme Court.`;
    printParagraph(noticeText);
  
    y += 20;
    doc.text('Name & Signature of Patient\'s relative ..................................', margin, y);
    doc.text('Relationship ..........................', pageWidth / 2 + 20, y);
    y += 25;
    doc.text('Name & Signature of Patient ...........................................', margin, y);
  
  
    // --- Final Step: Open PDF ---
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };
  
  const handlePrintConsentForm = (row = null) => {
    const data = row || {};
    // note: docList and nursesList are available in this component
    const doctor = (docList || []).find(d => String(d.user_id) === String(data.ot_doctor));
    const nurse = (nursesList || []).find(n => String(n.user_id) === String(data.ot_nurse_name));
    const pdfData = {
      config: { headerLogoUrl: headerLogo },
      patient: {
        name: data.ot_patient_name || "",
        age: data.ot_patient_age || "",
        gender: data.ot_patient_gender || "",
        uhid: data.ot_uhid_no || "",
        bed: getBedNameById(data.ot_bed) || "",
        guardian: data.guardian_name || ""
      },
      consultant: { name: doctor ? doctor.fname : "" },
      nurse: { name: nurse ? nurse.fname : "" },
      extra: { date: new Date().toLocaleDateString(), time: new Date().toLocaleTimeString() }
    };
    generateConsentFormPdf(pdfData);
  };
  

  const generateAnesthesiaRecordPdf =  async (anesthesiaData) => {
    // 1. PDF document setup karna
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    const contentWidth = pageWidth - (margin * 2);
    let y = margin; // 'y' vertical position ko track karega
  
       const headerImageBase64 = await imageUrlToBase64(headerLogo);
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 90); // Image ki height adjust kar sakte hain
    }
    y = 130;
    // 2. Document ka Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('ANAESTHESIA PRI - OPERATIVE RECORD', pageWidth / 2, y, { align: 'center' });
    doc.setLineWidth(1.5);
    doc.line(margin, y + 5, pageWidth - margin, y + 5);
    y += 30; // Title ke baad thoda gap
  
    // 3. Patient aur Hospital ki Details (2-column layout mein)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
  
    const leftX = margin;
    const rightX = pageWidth / 2 + 20;
  
    const printDetailRow = (leftLabel, leftValue, rightLabel, rightValue) => {
        doc.text(`${leftLabel} : ${leftValue || 'N/A'}`, leftX, y);
        if (rightLabel) {
            doc.text(`${rightLabel} : ${rightValue || 'N/A'}`, rightX, y);
        }
        y += 18; // Agli line ke liye 'y' ko badhao
    };
  
    printDetailRow('Name', anesthesiaData.patient.name, 'Age/Gender', `${anesthesiaData.patient.age || 'N/A'}/${anesthesiaData.patient.gender}`);
    printDetailRow('IPD No', anesthesiaData.patient.ipdNo, 'Date', anesthesiaData.date);
    printDetailRow('UHID No', anesthesiaData.patient.uhid, 'OT Doctor', anesthesiaData.doctor);
    printDetailRow('Contact', anesthesiaData.patient.contact, 'Ward', anesthesiaData.patient.ward);
    printDetailRow('Proposed Operation', anesthesiaData.proposedOperation, 'Bed', anesthesiaData.patient.bed);
    y += 10;
  
    // ===================================================================
    // YAHAN SE NAYA DESIGN SHURU HO RAHA HAI (AS PER YOUR IMAGE)
    // ===================================================================
  
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('1. Vitals', leftX, y);
    y += 15;
  
    // Vitals Table
    const tableTopY = y;
    const cellHeight = 35;
    const headers = ['BP\nmm-Hg', 'PULSE\nPm', 'Spo2\n%', 'WEIGHT\nkg', 'MP', 'TEETH &\nGUM', 'PHYSICAL\nSTATUS (ASA)'];
    const colWidth = contentWidth / headers.length;
  
    doc.setLineWidth(1);
    doc.rect(margin, y, contentWidth, cellHeight * 2); // Outer box for headers and values
  
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    headers.forEach((header, i) => {
        doc.line(margin + (colWidth * (i + 1)), tableTopY, margin + (colWidth * (i + 1)), tableTopY + (cellHeight * 2));
        doc.text(header, margin + (colWidth * i) + (colWidth / 2), tableTopY + 12, { align: 'center' });
    });
    doc.line(margin, tableTopY + cellHeight, pageWidth - margin, tableTopY + cellHeight); // Horizontal line separating header and value
  
    // Adding "@room air" under Spo2
    doc.setFont('helvetica', 'normal');
    doc.text('@room air', margin + (colWidth * 2) + (colWidth / 2), tableTopY + 30, { align: 'center' });
    
    // Adding ASA Classes under Physical Status
    doc.setFontSize(7);
    doc.text('I, II, III, IV, V, VI, E', margin + (colWidth * 6) + (colWidth / 2), tableTopY + 30, { align: 'center' });
  
  
    y += (cellHeight * 2) + 25; // Move 'y' past the table
  
    // --- Helper for dotted lines ---
    const drawLineWithText = (label, customY, isTwoCol = false) => {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text(label, leftX, customY);
        const textWidth = doc.getTextWidth(label);
        doc.setLineDashPattern([2, 2], 0); // Dotted line
        if(isTwoCol) {
            doc.line(leftX + textWidth + 5, customY, rightX - 10, customY);
        } else {
            doc.line(leftX + textWidth + 5, customY, pageWidth - margin, customY);
        }
        doc.setLineDashPattern([], 0); // Reset to solid line
    };
    
    // 2. PRE-EXISTING DISEASE
    drawLineWithText('2. PRE-EXISTING DISEASE :- YES/NO      if Yes with medication', y);
    y += 20;
    drawLineWithText('somking/Alcohol/Elicit drug/Herbal Medication :', y);
    y += 25;
  
    // 3. PREV SURGICAL HISTORY
    drawLineWithText('3. PREV SURGICAL HISTORY:-', y);
    y += 25;
  
    // 4. INVESTIGATION
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('4. INVESTIGATION:-', leftX, y);
    y += 20;
  
    const investigationFields = [
        { left: 'Hb% :', right: 'TC :' },
        { left: 'PLT COUNT :', right: 'RBS :' },
        { left: 'S. Creatinine :', right: 'PT INR :' },
        { left: 'TSH :', right: 'CXR :' },
        { left: 'BLOOD GROUP :', right: 'ECG :' },
        { left: 'VIRAL MARKERS :', right: 'Others :' },
        { left: 'OTHERS :', right: null },
    ];
    
    doc.setFont('helvetica', 'normal');
    investigationFields.forEach(field => {
        doc.text(`${field.left} ..........................`, leftX, y);
        if (field.right) {
            doc.text(`${field.right} ..........................`, rightX, y);
        }
        y += 20;
    });
    y += 10;
  
    // 5. SYSTEMIC EXAMINATION
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('5. SYSTEMIC EXAMINATION :-', leftX, y);
    y += 20;
    
    const systemicFields = [
        { left: 'CHEST :-', right: 'CNS :-' },
        { left: 'CVS :-', right: 'SPINE/ OTHERS :-' },
    ];
    
    doc.setFont('helvetica', 'normal');
    systemicFields.forEach(field => {
        doc.text(`${field.left} ..........................`, leftX, y);
        doc.text(`${field.right} ..........................`, rightX, y);
        y += 20;
    });
  
    doc.text('Neck movement - Adequate / Restricted', leftX, y);
    y += 20;
    doc.text('Mouth opening - Adequate / Restricted', leftX, y);
    y += 30;
  
    // 6. Advice
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('6. Advice :-', leftX, y);
    y += 60; // Extra space for advice
  
    // Signature
  doc.setFont('helvetica', 'normal');
  
  // Signature ko thoda niche kar diya (+5 pixels)
  doc.text('Signature', pageWidth - margin - 50, y + 7);
  
  // Line jaisi thi waisi hi rahegi
  doc.line(pageWidth - margin - 100, y - 5, pageWidth - margin, y - 5);
  
  
    // Final Step: Generate and open PDF
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };
  
  const handlePrintAnesthesiaRecord = async (row = null) => {
    try {
      const data = row || {};
      const bed = (bedsList || []).find((b) => String(b.bed_id) === String(data.ot_bed));
      const doctorName = getDoctorNameByIdSafe(data.ot_doctor);
  
      // ensure caseList loaded
      if (!Array.isArray(caseList) || caseList.length === 0) {
        await fetchCaseList();
      }
  
      let resolvedCaseName = "";
      const rawCase = data.ot_case;
      if (rawCase) {
        // try local resolution by id or name
        const local = (caseList || []).find(c => String(c.cat_id ?? c.case_id ?? c.id ?? "") === String(rawCase)) ||
                      (caseList || []).find(c => String(c.cat_name ?? "").toLowerCase().trim() === String(rawCase).toLowerCase().trim()) ||
                      (caseList || []).find(c => (String(c.cat_name ?? "").toLowerCase()).includes(String(rawCase).toLowerCase().trim()));
        if (local) resolvedCaseName = local.cat_name || local.name || String(rawCase);
        else if (!isNaN(Number(rawCase))) {
          // try server fetch by id
          const fetched = await fetchCaseNameById(rawCase);
          resolvedCaseName = fetched || String(rawCase);
        } else {
          resolvedCaseName = String(rawCase);
        }
      }
  
      const anaData = {
        patient: {
          name: data.ot_patient_name || "",
          ipdNo: data.ot_ipd_no ? `000${data.ot_ipd_no}` : "",
          uhid: data.ot_uhid_no || "",
          contact: data.ot_patient_mobile || "",
          age: data.ot_patient_age || "",
          gender: data.ot_patient_gender || "",
          ward: bed ? bed.cat_name : "",
          bed: bed ? bed.bed_name : ""
        },
        date: formatDate(data.ot_reg_date || new Date().toISOString()),
        doctor: doctorName,
        proposedOperation: resolvedCaseName || (data.ot_case || "")
      };
  
      await generateAnesthesiaRecordPdf(anaData);
    } catch (err) {
      console.error("handlePrintAnesthesiaRecord:", err);
      toast.error("Failed to generate Anaesthesia Record");
    }
  };
  

  /* ----------------- Filtered list (client-side check) ----------------- */
  // We still run client-side filters on the server-provided records for extra safety (server is primary)
  const filteredList = (Array.isArray(records) ? records : []).filter((item) => {
    const sk = (filters.search_key || "").trim().toLowerCase();
    if (sk) {
      const matches =
        String(item.ot_ipd_no || "").toLowerCase().includes(sk) ||
        String(item.ot_uhid_no || "").toLowerCase().includes(sk) ||
        String(item.ot_patient_name || "").toLowerCase().includes(sk);
      if (!matches) return false;
    }

    if (filters.from && filters.to) {
      // prefer ot_datetime; fall back to ot_reg_date for older records
      const rawDate = item.ot_datetime || item.ot_reg_date || "";
      const rec = new Date(rawDate);
      const fromD = new Date(filters.from + "T00:00:00");
      const toD = new Date(filters.to + "T23:59:59");
      // if server date couldn't be parsed, exclude the row (safe default)
      if (isNaN(rec)) return false;
      if (rec < fromD || rec > toD) return false;
    }
    

    if (filters.doctor_filter) {
      if (String(item.ot_doctor || "") !== String(filters.doctor_filter)) return false;
    }

    return true;
  });

  /* ----------------- Handlers ----------------- */
  const onSearch = () => {
    setFilters(prev => ({ ...prev, page_no: 0 }));
    initData(0, { from: filters.from, to: filters.to, search_key: filters.search_key, doctor_filter: filters.doctor_filter });
  };

  const onClear = () => {
    setFilters(prev => ({ ...prev, search_key: "", from: todayISO, to: todayISO, doctor_filter: "", page_no: 0 }));
    initData(0, { from: todayISO, to: todayISO, search_key: "", doctor_filter: "" });
  };

  const changePage = (inc) => {
    const next = Math.max(0, (filters.page_no || 0) + inc);
    setFilters(prev => ({ ...prev, page_no: next }));
    initData(next, { from: filters.from, to: filters.to, search_key: filters.search_key, doctor_filter: filters.doctor_filter });
  };
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',      // larger header text
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px', // row font size
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',      // larger body text
        lineHeight: '20px'
      }
    },
  };
  /* ---------------- DataTable columns ---------------- */
  const columns = [
    {
      name: "",
      cell: (row) => {
        const key = row._dt_key || `row_${row.ot_id || Math.random()}`;
    
        return (
          <div
            className="ot-row-actions"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              minHeight: "38px", // keeps row height consistent
            }}
          >
            {/* View button - always visible */}
            <div className="ot-view-area" style={{ flexShrink: 0 }}>
              <button
                className="btn btn-sm btn-primary ot-view-btn"
                onClick={() => handleViewClick(row.ot_uhid_no || row.ot_uhid, row)}
                title="View patient details"
              >
                View
              </button>
            </div>
    
            {/* 3-dot dropdown */}
            <div
              className="ot-dropdown-container"
              style={{ position: "relative", flexShrink: 0 }}
            >
              <button
                className="btn btn-link text-muted p-0"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpenIndex((prev) => (prev === key ? null : key));
                }}
              >
                <i className="ri-more-2-fill fs-18"></i>
              </button>
    
              {dropdownOpenIndex === key && (
                <div
                  className="card p-2 shadow-sm"
                  style={{
                    position: "relative",
                    top: "100%",
                    right: 0,
                    zIndex: 60,
                    minWidth: "200px",
                  }}
                >
                  <button
                    className="dropdown-item"
                    onClick={() => handlePrintOtReceipt(row)}
                  >
                    Print OT Receipt
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handlePrintConsentForm(row)}
                  >
                    Print Consent Form
                  </button>
                  <button
                    className="dropdown-item"
                    onClick={() => handlePrintAnesthesiaRecord(row)}
                  >
                    Print Anaesthesia Form
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      },
      width: "170px",
    },
    

    
    
    { name: "S. No.", selector: (row, idx) => idx + 1, sortable: true, width: "90px" },
    { name: "UHID No.", selector: row => row.ot_uhid_no || "", sortable: true,width: "180px" },
    { name: "Reg Date", selector: row => formatDateTime(row.ot_datetime) || "", sortable: true, width: "200px" },

    { name: "Patient Name", selector: row => row.ot_patient_name || "", sortable: true,width: "190px" },
    { name: "OT No.", selector: row => row.ot_number || "", sortable: true ,width: "110px"},
    // { name: "OT Case", selector: row => findCaseNameById(row.ot_case) || "", sortable: true },
    { name: "OT Surgeon", selector: row => getDoctorNameById(row.ot_doctor) || "", sortable: true,width: "220px" },
    { name: "Anesthesia Doctor", selector: row => getDoctorNameById(row.ot_anesthesia_doctor) || "", sortable: true,width: "220px" },
    { name: "OT Nurse", selector: row => row.ot_nurse_name || "", sortable: true,width: "190px" },
    { name: "OT Asst. Nurse", selector: row => row.ot_asst_nurse || "", sortable: true,width: "190px" },
    {
      name: "Action",
      cell: (row) => {
        // allowed to edit if user is admin OR the OT is within 24 hours
        const editable = canEditOt(row.ot_datetime);
        const canEdit = isAdmin || editable;
    
        // Title messaging for tooltip
        const editTitle = isAdmin
          ? "Edit OT (admin — always allowed)"
          : (editable ? "Edit OT" : "Cannot edit: registered > 24 hrs");
    
        return (
          <div>
            <button
              type="button"
              disabled={!canEdit}
              style={{
                opacity: !canEdit ? 0.5 : 1,
                pointerEvents: !canEdit ? "none" : "auto"
              }}
              onClick={() => handleEditClick(row)}
              className="btn btn-warning btn-sm"
              title={editTitle}
            >
              Edit
            </button>
            &nbsp;
            <button
              type="button"
              disabled={!isAdmin}
              style={{
                opacity: !isAdmin ? 0.5 : 1,
                pointerEvents: !isAdmin ? "none" : "auto"
              }}
              onClick={() => {
                Swal.fire({
                  title: "Confirm delete",
                  text: "Are you sure you want to delete this OT record?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, delete",
                  cancelButtonText: "Cancel"
                }).then((result) => {
                  if (result.isConfirmed) {
                    delItem(row);
                  }
                });
              }}
              className="btn btn-danger btn-sm"
              title={!isAdmin ? "Admin only" : "Delete OT"}
            >
              Delete
            </button>
          </div>
        );
      },
      width: "200px"
    }
    
    
  ];

  // mark records with unique key for dropdown handling
  const tableData = (filteredList || []).map((r, i) => ({ ...r, _dt_key: `row_${i}_${r.ot_id || ""}` }));

  /* ----------------- Render ----------------- */
  return (
    <div className="page-content">
       {/* Inline CSS Styles */}
    <style>{`
      .ot-view-btn {
        padding: 4px 10px;
        font-size: 13px;
        line-height: 1.3;
      }
      .ot-row-actions {
        min-height: 38px; /* keeps stable height */
      }
    `}</style>
      <div className="container-fluid">
        <div className="card" id="orderList">
          <div className="card-header border-0">
            <div className="row align-items-center gy-3">
              <div className="col-sm">
                <h5 className="card-title mb-0">OT Management</h5>
              </div>
              <div className="col-sm-auto">
                <div className="d-flex gap-1 flex-wrap">
                  <a href="#" onClick={(e) => { e.preventDefault(); sessionStorage.removeItem("ot_dt"); window.location.href = "/add_ot"; }}>
                    <button type="button" className="btn btn-success add-btn"><i className="ri-add-line align-bottom me-1"></i> Add OT</button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body border border-dashed border-end-0 border-start-0">
            <form onSubmit={(e) => { e.preventDefault(); onSearch(); }}>
              <div className="row g-3">
                <div className="col-md-2">
                  <label className="form-label">From</label>
                  <input className="form-control" type="date" value={filters.from} onChange={(e) => setFilters(prev => ({ ...prev, from: e.target.value }))} />
                </div>
                <div className="col-md-2">
                  <label className="form-label">To</label>
                  <input className="form-control" type="date" value={filters.to} onChange={(e) => setFilters(prev => ({ ...prev, to: e.target.value }))} />
                </div>

                <div className="col-md-2">
  <label className="form-label">Doctor</label>
  <Select
    isClearable
    placeholder="All Doctors"
    value={
      (filters.doctor_filter && docList.find(d => String(d.user_id) === String(filters.doctor_filter)))
        ? { value: String(filters.doctor_filter), label: docList.find(d => String(d.user_id) === String(filters.doctor_filter)).fname }
        : null
    }
    onChange={(opt) => {
      const v = opt ? opt.value : "";
      setFilters(prev => ({ ...prev, doctor_filter: v }));
    }}
    options={(docList || []).map(d => ({ value: String(d.user_id), label: d.fname }))}
    styles={{
      control: (base) => ({ ...base, minHeight: '38px' }),
      menu: (base) => ({ ...base, zIndex: 1000 })
    }}
  />
</div>


                <div className="col-md-3">
                  <label className="form-label">Search</label>
                  <div className="d-flex">
                    <input className="form-control" placeholder="UHID / Name / IPD" value={filters.search_key} onChange={(e) => setFilters(prev => ({ ...prev, search_key: e.target.value }))} />
                    {/* <button type="button" className="btn btn-success ms-2" onClick={onSearch}>Search</button> */}
                    <button type="button" className="btn btn-info ms-2" onClick={onClear}>Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body pt-0">
            <div className="table-responsive table-card mb-1">
            <DataTable
                      columns={columns}
                      data={filteredList}
                      pagination
                      highlightOnHover
                      responsive
                      persistTableHead
                      customStyles={customStyles}
                      noHeader
                    />
            </div>

            <div className="d-flex justify-content-end">
              <div className="pagination-wrap hstack gap-2">
                {/* <a className="page-item pagination-prev" href="#" onClick={(e) => { e.preventDefault(); changePage(-1); }}>Previous</a> */}
                <ul className="pagination listjs-pagination mb-0"></ul>
                {/* <a className="page-item pagination-next" href="#" onClick={(e) => { e.preventDefault(); changePage(1); }}>Next</a> */}
              </div>
            </div>

            <DelBox />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtManagement;
